export default function DataMonitoring(){
    return (
        <div>
            Upcoming Feature
        </div>
    )
}